/** Default proximity radius for convoy live-position clustering (ENG-2580 / ENG-2674).
 * Keep in sync with gpx-device-api ConvoyRules::PROXIMITY_RADIUS_METERS.
 */
export const CONVOY_PROXIMITY_RADIUS_METERS = 1000;

/** Treat expanded pins as stacked (spiderfy) when closer than this. */
export const CONVOY_SPIDERFY_STACK_EPSILON_METERS = 8;

/** Base circle radius for stacked expanded pins (grows with count). */
export const CONVOY_SPIDERFY_RADIUS_METERS = 22;
